/* eslint-disable */
/*
TODO: use @babel/polyfill to have
Promise.allSettled;
this one is from https://medium.com/trabe/using-promise-allsettled-now-e1767d43e480
*/

const mapPromise = (promise) => promise
    .then((value) => ({
        status: 'fulfilled',
        value,
    }))
    .catch((reason) => ({
        status: 'rejected',
        reason,
    }));

export default function allSettled(promises) {
    return Promise.all(
        promises.map(mapPromise),
    );
}
